/// ROUTER ///
import { useNavigate } from "react-router-dom";
/// TYPES ///
import { ISelfOrderEvent } from "api/types/event";
/// FM ///
import { motion } from "framer-motion";
/// STYLES ///
import {
  dayEventItemStyle
} from "styles/calendar/day";
/// URLS ///
import { shop_url } from "components/navigation/endpoints";
import { event_url } from "components/navigation/endpoints";

interface Props {
  self_order_event: ISelfOrderEvent
}

export default function SelfOrderDayItem({ self_order_event }: Props) {
  const navigate = useNavigate();

  return (
    <motion.button
      initial={{ scale: 1 }}
      whileHover={{ scale: 1.05 }}
      onClick={() => navigate(`/${event_url}/${shop_url}/${self_order_event?.self_order}`)}
      style={dayEventItemStyle(self_order_event?.color)}>
      {self_order_event?.title ?? ""}
    </motion.button>
  )
}
